import { usePickerState } from './usePickerState';
export function useStaticState(_ref) {
  var value = _ref.value,
    _ref$autoOk = _ref.autoOk,
    autoOk = _ref$autoOk === void 0 ? true : _ref$autoOk,
    onChange = _ref.onChange,
    defaultFormat = _ref.defaultFormat;
  var _usePickerState = usePickerState({
      value: value,
      onChange: onChange,
      autoOk: autoOk
    }, {
      // just a random format, mostly always not needed for users
      getDefaultFormat: function getDefaultFormat() {
        return defaultFormat || 'MM/dd/yyyy';
      }
    }),
    pickerProps = _usePickerState.pickerProps,
    wrapperProps = _usePickerState.wrapperProps,
    inputProps = _usePickerState.inputProps;
  return {
    pickerProps: pickerProps,
    wrapperProps: wrapperProps,
    inputProps: inputProps
  };
}